var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.fullStars),function(n){return _c('span',{staticClass:"icon ion-ios-star star-icon"})}),(_vm.hasHalfStar)?_c('span',{staticClass:"icon ion-ios-star-half star-icon"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }